/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

// Fallback seguro para evitar quebra do app quando variáveis não forem fornecidas.
// O fluxo real de login SSO usa as configurações dinâmicas carregadas em SignIn.
const defaultClientId = "04b07795-8ddb-461a-bbee-02f9e1bf7b46";
const azureClientId = /* process.env.REACT_APP_AZURE_CLIENT_ID  ||*/ defaultClientId;
const azureTenantId = /* process.env.REACT_APP_AZURE_TENANT_ID || */ "common";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        clientId: azureClientId,
        authority: `https://login.microsoftonline.com/${azureTenantId}`
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {		
                    case LogLevel.Error:		
                        console.error(message);		
                        return;		
                    case LogLevel.Info:		
                        console.info(message);		
                        return;		
                    case LogLevel.Verbose:		
                        console.debug(message);		
                        return;		
                    case LogLevel.Warning:		
                        console.warn(message);		
                        return;		
                }	
            }	
        }	
    }
};
